import Button from '../../components/Button';

const innerContents = (props) => {
  const {contentTitle, contentSubTitle} = props;

  return (
    <div className="contentWrapper">
      <h3 className="contentTitle">{contentTitle}</h3>
      <h4 className="contentSubTitle">{contentSubTitle}</h4>
      <Button innerText={"2주 무료 이용 시작"} />
    </div>
  )
}

export default innerContents;